'use client';

import type {
  CampaignContactPerson,
} from '@/types/campaigns';
import type { CallSummary } from '@/types/telephony';

export function isPooledAgentLine(call: CallSummary | null | undefined): boolean {
  return call?.source === 'pooled_dialer' && (call.destination === 'park' || call.toPhone === 'park');
}

export function formatElapsed(startIso: string | null, endIso: string | null, nowTs: number): string {
  if (!startIso) return '00:00';
  const start = new Date(startIso).getTime();
  const end = endIso ? new Date(endIso).getTime() : nowTs;
  const seconds = Math.max(0, Math.floor((end - start) / 1000));
  const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');
  return `${mm}:${ss}`;
}

/**
 * Start anchor for the live call-duration timer. Once a call bridges we count
 * talk time from the connect moment (`bridgedAt`); before the bridge, ring time
 * from `createdAt`. This matters most in pooled dialing, where `createdAt` is
 * the dial-ahead origination — up to ~a minute before an agent is bridged —
 * so anchoring the timer on `createdAt` made every connected call open around
 * 1:00 and keep climbing across contacts instead of resetting.
 */
export function liveCallStartIso(call: { createdAt: string; bridgedAt: string | null }): string {
  return call.bridgedAt ?? call.createdAt;
}

export function formatContactName(contact: CampaignContactPerson): string {
  return contact.companyName?.trim() || contact.name?.trim() || '(no company name)';
}
